export const benefitsEnhancement = [
	{
		icon: '🔹',
		subtitle: 'benefitData_subtitle1',
	},
	{
		icon: '🔹',
		subtitle: 'benefitData_subtitle2',
	},
	{
		icon: '🔹',
		subtitle: 'benefitData_subtitle3',
	},
	{
		icon: '🔹',
		subtitle: 'benefitData_subtitle4',
	},
	{
		icon: '🔹',
		subtitle: 'benefitData_subtitle5',
	},
	{
		icon: '🔹',
		subtitle: 'benefitData_subtitle6',
	},
	{
		icon: '🔹',
		subtitle: 'benefitData_subtitle7',
	},
];
